import { Button, Flex, Heading, Text } from "@chakra-ui/react";
import { useState } from "react";

export const Nav = () => {
	const [focused, setFocused] = useState<string>();

	const NavSymbol = ({ adjacentTo }: { adjacentTo: string[] }) => {
		const isFocused = adjacentTo.find((button) => button === focused);
		return (
			<Text fontSize="sm" color={isFocused ? "brand.contrast" : "brand.dark"}>
				✦
			</Text>
		);
	};

	const WebNavButton = (props: { label: string; route: string }) => {
		return (
			<Button
				onClick={() => window.location.replace(`/#${props.route}`)}
				onMouseEnter={() => setFocused(props.route)}
				onMouseLeave={() => setFocused(undefined)}
				_hover={{ color: "brand.contrast" }}
				fontFamily="Kalnia Variable"
				variant="unstyled"
				h="fit-content"
				fontSize="sm"
			>
				{props.label.toUpperCase()}
			</Button>
		);
	};

	return (
		<Flex
			px="8"
			py="2"
			gap="8"
			w="100%"
			zIndex={1}
			bottom="0"
			align="center"
			position="fixed"
			justify="space-between"
			backdropFilter="blur(1px)"
			bg="rgba(255, 254, 250, .8)"
		>
			<Button
				variant="unstyled"
				_hover={{ color: "brand.contrast" }}
				onClick={() => window.location.replace("/#")}
			>
				<Heading>LULU</Heading>
			</Button>

			<Flex gap={{ md: "2", lg: "3" }} align="center">
				<NavSymbol adjacentTo={["experience"]} />
				<WebNavButton label="experience" route="experience" />
				<NavSymbol adjacentTo={["experience", "compensation"]} />
				<WebNavButton label="compensation" route="compensation" />
				<NavSymbol adjacentTo={["compensation", "testimonials"]} />
				<WebNavButton label="testimonials" route="testimonials" />
				<NavSymbol adjacentTo={["testimonials", "faqs"]} />
				<WebNavButton label="faqs" route="faqs" />
				<NavSymbol adjacentTo={["faqs"]} />
				<Button
					size="xs"
					rounded="3"
					fontSize="sm"
					bg="brand.dark"
					color="brand.light"
					fontFamily="Kalnia Variable"
					_hover={{ bg: "brand.contrast" }}
					onMouseLeave={() => setFocused(undefined)}
					onMouseEnter={() => setFocused("contact")}
					onClick={() => window.location.replace("/#contact")}
				>
					GET IN TOUCH
				</Button>
			</Flex>
		</Flex>
	);
};
